<template lang="pug">
.menu.briq-menu-panel.type-standard
  a.menu-user.menu-option(:href="accountLink")
    .avatar
      img(:src="userDetails.imageUrl")
    .user
      .bold {{ userDetails.name }}
      .role.type-small {{ userDetails.role }}
  a.menu-option(:href="settingsLink") Settings
  a.menu-option(:href="reportsLink") Reports
  a.menu-option(:href="logoutLink") Log out
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BriqAccountMenu',
  computed: {
    ...mapState('user', ['userDetails']),
    userName() {
      return 'Dummy Pietje' // todo: get from store
    },
    userRole() {
      return 'SystemAdministrator' // todo: get from store
    },
    accountLink() {
      return this.linkTo('settings/account')
    },
    settingsLink() {
      return this.linkTo('settings/application/main')
    },
    reportsLink() {
      return this.linkTo('reports/worklists')
    },
    logoutLink() {
      return this.linkTo('logout')
    },
  },
  methods: {
    linkTo(path) {
      return `${location.protocol}//${location.hostname}/${path}`
    },
  },
}
</script>

<style scoped lang="stylus">
.menu
  position absolute
  bottom 15px
  right -226px
  width 232px

  &::after
    content ''
    width 0
    height 0
    border-style solid
    border-width 7px 8px 7px 0
    border-color transparent #2c333a transparent transparent
    display block
    position absolute
    left -8px
    bottom 20px

  .menu-user, .menu-business-unit
    position relative
    display flex

  .menu-user
    .avatar
      height 32px
      width 32px
      margin-right 10px

      img
        height 100%
        width 100%
        border-radius 50%
        object-fit cover

    .user
      overflow hidden
      text-overflow ellipsis

  .menu-user::after, .menu-business-unit::after
    content ''
    background #343c43
    height 1px
    position absolute
    bottom 0
    left 20px
    right 20px

.briq-menu-panel
  color white
  margin 0
  padding 10px 0
  width 232px
  border-radius 3px
  background-color #2c333a
  box-shadow 0 2px 4px 0 rgba(0, 0, 0, 0.15)

.menu-option
  color white
  padding 6px 20px
  display block
  cursor pointer

  &:hover
    color white
    background #343c43
</style>
